import { useCallback, useMemo } from "react"

import * as turf from "@turf/turf"

import { CatalogItemDetailsForm } from "@l2r-front/l2r-common"
import { sanitizeData } from "@l2r-front/l2r-geodata"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { useNetworkReferential, useSubNetworksWithWriteAccess } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { NavigationOrigins, useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { API_MODULE_HORIZONTAL_SIGNING } from "../../../../common/constants/modules"
import { useHorizontalSignUpdate } from "../../hooks/mutations/useHorizontalSignUpdate"


export const HorizontalSignLocationEditFormPost = (props) => {

    const {
        close,
        signId,
        startingPosition,
        startingRoad,
        onMutationRunning,
        ...otherProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const navigate = useNavigateWithSearchParams()
    const { setMapPin } = useMapDispatchContext()

    const subNetworks = useSubNetworksWithWriteAccess(null, API_MODULE_HORIZONTAL_SIGNING)
    const { data: referential } = useNetworkReferential({}, {}, subNetworks)
    const sanitizedReferential = useMemo(() => {
        return sanitizeData(referential)
    }, [referential])

    const mutation = useHorizontalSignUpdate(signId, {}, {
        onSuccess: (data) => {
            setMapPin()
            onMutationRunning(false)
            close(false)
            navigate(`../${data.linear_location.road}/${data.uuid}`, { navigationOrigin: NavigationOrigins.DETAIL_FROM_DETAIL })
        },
        onError: () => {
            onMutationRunning(false)
        },
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.horizontalSignLocationEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.horizontalSignLocationEditForm.snackbar.success"),
    })

    const onSubmit = useCallback(values => {

        const linearLocation = {
            typeid: 0,
            road: values.road.road,
            start: values.road.start,
            end: values.road.start + 1,
        }
        const point = turf.point([values.position.longitude, values.position.latitude])

        mutation.mutate({ linear_location: linearLocation, geometry: point.geometry })
        onMutationRunning(true)
    }, [onMutationRunning, mutation])

    return <CatalogItemDetailsForm
        {...otherProps}
        referential={sanitizedReferential}
        startingPosition={startingPosition}
        startingRoad={startingRoad}
        subNetworks={subNetworks}
        onSubmit={onSubmit}
        onCancel={close}
    />
}

HorizontalSignLocationEditFormPost.propTypes = {
    close: PropTypes.func.isRequired,
    signId: PropTypes.string.isRequired,
    startingPosition: PropTypes.shape({
        longitude: PropTypes.number,
        latitude: PropTypes.number,
    }).isRequired,
    startingRoad: PropTypes.string,
}